/**
 * The damage wheel from PRD #713: the element union and nothing else.
 *
 * This is a leaf module by design. PRD #803 declared the union in
 * `abilityCatalog.ts`, and it stayed there while the catalog was the only
 * authored content that named an element. The elemental statuses (PRD #804)
 * ended that: `statuses.ts` now declares typed damage-over-time and per-type
 * resist adjustments, and `abilityCatalog.ts` already imports `statuses.ts` for
 * the counterplay law, so the union had to move below both to keep the import
 * graph acyclic. `abilityCatalog.ts` re-exports both names, so every existing
 * import site still reads them from where PRD #803 put them.
 */

/**
 * One entry on the damage wheel. Every `damage` payload declares one, so no
 * ability, affix, or monster authored later has to migrate untyped damage.
 */
export type DamageType = 'physical' | 'fire' | 'cold' | 'poison' | 'energy';

export const DAMAGE_TYPES: readonly DamageType[] = [
  'physical',
  'fire',
  'cold',
  'poison',
  'energy',
];
